import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App as AntApp, ConfigProvider } from 'antd'
import App from './App'
import './styles/seller.css'
import 'bootstrap-icons/font/bootstrap-icons.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: '#0f766e',
        colorInfo: '#0f766e',
        colorSuccess: '#15803d',
        colorWarning: '#b45309',
        colorError: '#b91c1c',
        colorText: '#102a2a',
        colorTextSecondary: '#5f7171',
        colorBgLayout: '#f3f8f8',
        colorBgContainer: '#ffffff',
        borderRadius: 10,
        wireframe: false,
      },
      components: {
        Button: {
          borderRadius: 10,
          controlHeightLG: 46,
          fontWeight: 700,
        },
        Card: {
          borderRadiusLG: 12,
          paddingLG: 22,
        },
        Layout: {
          bodyBg: '#f3f8f8',
          headerBg: '#ffffff',
          siderBg: '#0f172a',
        },
        Menu: {
          darkItemBg: '#0f172a',
          darkSubMenuItemBg: '#0b1322',
          darkItemSelectedBg: '#0f766e',
        },
      },
    }}
  >
    <AntApp>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AntApp>
  </ConfigProvider>,
)
